import { useState, useEffect } from 'react';
import { VacationsRequest } from '../models/RequestWidget.interface';
import axios from 'axios';
import { getStatusCodeNumber } from 'src/utils/mappers/checkStatusCode';
import { checkVacationTypeId } from 'src/utils/mappers/checkVacationType';
import { VacationType } from 'src/tabs/hooks/useVacationTypes';
import { dateFilterMapper } from 'src/utils/dateFns/dateFilterMapper';

export const useGetUserRequests = (
  vacationStatus: string[],
  vacationTypes: string[],
  vacationIds: VacationType[],
  filterDate: Date | 'Full Year',
  filterDateType: string,
  filterDirection: string,
  year?: number,
  sortBy?: string
) => {
  const [requests, setRequests] = useState<VacationsRequest[]>([]);
  const [loadingRequest, setLoadingRequest] = useState<boolean>();

  const dateString = dateFilterMapper(filterDate, filterDateType, year);
  const getUserRequests = async () => {
    const statusCodes =
      vacationStatus?.length > 0 &&
      vacationStatus.map((statusName) => getStatusCodeNumber(statusName));
    const filterStatusCode =
      vacationStatus?.length > 0
        ? statusCodes.map((status) => `&statusCode[]=${status}`)
        : [];

    const vacationTypeIds =
      vacationTypes?.length > 0 &&
      vacationIds?.length > 0 &&
      vacationTypes.map((vacation) =>
        checkVacationTypeId(vacationIds, vacation)
      );
    const filterVacationtypeId =
      vacationTypes?.length > 0
        ? vacationTypeIds.map((vacation) => `&vacationTypeId[]=${vacation}`)
        : [];

    try {
      setLoadingRequest(true);
      const { data } = await axios.get(
        `api/vacation-requests/filtered/my/${year}?${filterVacationtypeId.join(
          ''
        )}${filterStatusCode.join(
          ''
        )}${dateString}&sortBy=${sortBy}&sort=new_startdate&direction=${filterDirection}`
      );
      data && setRequests(data);
    } catch (err) {
      setRequests([]);
      console.log(err);
    } finally {
      setLoadingRequest(false);
    }
  };

  useEffect(() => {
    getUserRequests();
  }, [
    vacationStatus,
    vacationTypes,
    filterDate,
    filterDateType,
    filterDirection,
    sortBy,
  ]);

  return { requests, loadingRequest, getUserRequests };
};
